import { CreatorStudioMode } from "../types/creator-studio";

export interface CreatorStudioTemplate {
  id: string;
  label: string;
  description: string;
  platformFit: string;
  modes: CreatorStudioMode[];
  instruction: string;
}

export const CREATOR_STUDIO_TEMPLATES: CreatorStudioTemplate[] = [
  {
    id: "linkedin_practical_lesson",
    label: "LinkedIn practical lesson",
    description: "A useful takeaway with a clear reason and simple next step.",
    platformFit: "LinkedIn",
    modes: [CreatorStudioMode.SOCIAL_POST],
    instruction:
      "Use a LinkedIn practical lesson format. Open with a grounded observation, explain why it matters, give 2-4 practical points, and end with a soft question or next step. Keep it specific and useful. Avoid hype, exaggerated claims, and generic AI language.",
  },
  {
    id: "linkedin_founder_pov",
    label: "LinkedIn founder POV",
    description: "A founder-led point of view from a real problem or decision.",
    platformFit: "LinkedIn",
    modes: [CreatorStudioMode.SOCIAL_POST],
    instruction:
      "Use a LinkedIn founder POV format. Start with a direct personal observation or lesson, connect it to the user's topic, share a clear point of view, and end with a practical reflection. It should sound human, specific, and lightly opinionated, not like a brand announcement.",
  },
  {
    id: "linkedin_checklist",
    label: "LinkedIn checklist",
    description: "A skimmable checklist people can save or act on.",
    platformFit: "LinkedIn",
    modes: [CreatorStudioMode.SOCIAL_POST],
    instruction:
      "Use a LinkedIn checklist format. Start with the outcome the reader wants, then list concise checklist items with short explanations. Make every item actionable. Avoid over-explaining and do not turn the post into a sales pitch.",
  },
  {
    id: "x_short_take",
    label: "X short take",
    description: "A sharp, short post built around one idea.",
    platformFit: "X",
    modes: [CreatorStudioMode.SOCIAL_POST],
    instruction:
      "Use an X short-take format. Keep the copy compact, direct, and easy to quote. Focus on one idea only. Prefer plain language, a strong first line, and no filler. Avoid long lists unless the user explicitly asks for them.",
  },
  {
    id: "x_mini_thread",
    label: "X mini-thread",
    description: "A short thread-style structure with a hook and 3-5 points.",
    platformFit: "X",
    modes: [CreatorStudioMode.SOCIAL_POST],
    instruction:
      "Use an X mini-thread format. Write like a short thread: hook first, then 3-5 compact points, then a simple closing line. Keep each point clear enough to stand alone. Do not use exaggerated thread-bait language.",
  },
  {
    id: "blog_insight_read_more",
    label: "Blog insight + read more",
    description: "A useful social teaser that earns the click before the link.",
    platformFit: "Blog promotion",
    modes: [CreatorStudioMode.BLOG_PROMOTION],
    instruction:
      "Use a blog promotion format. Start with one useful insight from the article, explain why it matters in 1-2 lines, and include one natural Read more line near the end. The post should be valuable even before someone clicks the link.",
  },
];

export const getCreatorStudioTemplateById = (
  templateId?: string | null
): CreatorStudioTemplate | undefined =>
  CREATOR_STUDIO_TEMPLATES.find((template) => template.id === templateId);

export const getCreatorStudioTemplatesForMode = (
  mode: CreatorStudioMode
): CreatorStudioTemplate[] =>
  CREATOR_STUDIO_TEMPLATES.filter((template) => template.modes.includes(mode));
